function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import { withRouter } from "react-router";
import { Card, Empty, Search, Filters, PlunkDropDown } from "../../components/analytics-kit";
import { Loader } from "../../components/loaders";
import Error from "../../components/error";
import { listQuotes, getQuotesSummary, listReps, isAdminUser, currentUserEmail } from "../sales/sales-quotes-api";
import { QuotesGate, QuotesShell, QuoteStatus, Btn, money0, fmtDate, daysUntil, companyName, OPEN_STATUSES, quoteStatusLabel, normStatus } from "./common";

/*
 * Quotes list (SALES_QUOTES_ORDER_DESK.md §7, mockup A): status chips as
 * filters (Open · Draft · Sent · Viewed · Accepted · Expiring in 7 days),
 * rep and owner dropdowns, search, "New quote". Read: GET /v1/sales/quotes
 * (fail-soft: a calm line until the route lands). The acceptance line comes
 * from /quotes/summary/{range} when it answers.
 *
 * Deep links: ?customerId= (from a dealer page), ?rep= (from a rep page), ?status=.
 */
const CHIPS = [["open", "Open"], ["draft", "Draft"], ["pending_approval", "Pending approval"], ["sent", "Sent"], ["viewed", "Viewed"], ["converted", "Accepted"], ["expiring", "Expiring in 7 days"]];
class QuotesListView extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "open", r => this.props.history.push(`/Quotes/${encodeURIComponent(r.id)}`));
    const sp = new URLSearchParams(props.location && props.location.search || "");
    this.state = {
      rows: undefined,
      summary: undefined,
      reps: [],
      error: false,
      chip: sp.get("status") || "open",
      rep: sp.get("rep") || "",
      owner: sp.get("owner") || (isAdminUser() ? "" : "me"),
      q: sp.get("q") || "",
      customerId: sp.get("customerId") || "",
      customerName: sp.get("customer") || ""
    };
    this._alive = true;
  }
  componentDidMount() {
    this.load();
    listReps().then(r => this._alive && this.setState({
      reps: r || []
    })).catch(() => {});
    getQuotesSummary("this_quarter").then(s => this._alive && this.setState({
      summary: s
    })).catch(() => this._alive && this.setState({
      summary: null
    }));
  }
  componentWillUnmount() {
    this._alive = false;
  }
  load() {
    const {
      customerId
    } = this.state;
    listQuotes({
      customerId: customerId || undefined
    }).then(rows => this._alive && this.setState({
      rows
    })).catch(() => this._alive && this.setState({
      error: true
    }));
  }
  filtered() {
    const {
      rows,
      chip,
      rep,
      owner,
      q
    } = this.state;
    const me = currentUserEmail().toLowerCase();
    const t = q.trim().toLowerCase();
    return (rows || []).filter(r => {
      if (chip === "open" && !OPEN_STATUSES.includes(r.status)) return false;
      if (chip === "expiring") {
        const d = daysUntil(r.validUntil);
        if (!["sent", "viewed"].includes(r.status) || d == null || d < 0 || d > 7) return false;
      }
      if (chip !== "open" && chip !== "expiring" && chip !== "all" && normStatus(r.status) !== chip) return false;
      if (rep && String(r.repCode) !== rep) return false;
      if (owner === "me" && me && String(r.owner || "").toLowerCase() !== me) return false;
      if (t && !`${r.number} ${r.customerName} ${r.customerNumber} ${r.title} ${r.repName} ${r.repCode}`.toLowerCase().includes(t)) return false;
      return true;
    });
  }
  counts() {
    const rows = this.state.rows || [];
    const c = {
      open: 0,
      openValue: 0
    };
    rows.forEach(r => {
      const st = normStatus(r.status);
      c[st] = (c[st] || 0) + 1;
      if (OPEN_STATUSES.includes(r.status)) {
        c.open += 1;
        c.openValue += Number(r.subtotalNet) || 0;
      }
      const d = daysUntil(r.validUntil);
      if (["sent", "viewed"].includes(r.status) && d != null && d >= 0 && d <= 7) c.expiring = (c.expiring || 0) + 1;
    });
    return c;
  }
  noteFor(r) {
    const d = daysUntil(r.validUntil);
    if (r.status === "viewed" && r.viewedDate) return `viewed ${fmtDate(r.viewedDate, false)}`;
    if (r.status === "pending_approval") return "override beyond the tier's limit";
    if (["sent", "viewed"].includes(r.status) && d != null && d >= 0 && d <= 7) return `${d === 0 ? "expires today" : `${d} day${d === 1 ? "" : "s"} left`} · extend?`;
    if (normStatus(r.status) === "converted") return [r.orderRequestNumber, r.orderStatus ? String(r.orderStatus).replace(/_/g, " ") : "", r.accepted && r.accepted.po ? `PO ${r.accepted.po}` : ""].filter(Boolean).join(" · ");
    if (r.status === "declined" && r.declinedReason) return `"${r.declinedReason}"`;
    if (r.status === "expired") return "ask for a refresh or extend";
    return "";
  }
  render() {
    const {
      rows,
      summary,
      reps,
      error,
      chip,
      rep,
      owner,
      q,
      customerName,
      customerId
    } = this.state;
    if (error) return /*#__PURE__*/React.createElement(Error, null);
    const admin = isAdminUser();
    const c = this.counts();
    const list = rows ? this.filtered() : [];
    const sub = summary ? `Acceptance ${summary.acceptanceRate != null ? `${Math.round(summary.acceptanceRate)}%` : "—"} this quarter${summary.medianDaysToAccept != null ? ` · median ${summary.medianDaysToAccept} days to accept` : ""}${summary.pendingErp ? ` · ${summary.pendingErp} request${summary.pendingErp === 1 ? "" : "s"} pending the ERP` : ""}` : "Quotes to dealers: lines from the catalog, dealer-tier pricing, a branded acceptance link, then an order request for the ERP";
    const chipList = CHIPS.map(([k, l]) => ({
      k,
      l,
      n: k === "open" ? c.open : c[k] || 0
    }));
    return /*#__PURE__*/React.createElement(QuotesGate, null, /*#__PURE__*/React.createElement(QuotesShell, {
      subtitle: sub,
      chips: [companyName() ? {
        k: "Workspace",
        v: companyName()
      } : null, customerName || customerId ? {
        k: "Dealer",
        v: customerName || customerId
      } : null],
      actions: /*#__PURE__*/React.createElement(React.Fragment, null, customerId ? /*#__PURE__*/React.createElement(Btn, {
        onClick: () => {
          this.setState({
            customerId: "",
            customerName: ""
          }, () => {
            this.props.history.replace("/Quotes");
            this.load();
          });
        }
      }, "All dealers") : null, /*#__PURE__*/React.createElement(Btn, {
        primary: true,
        onClick: () => this.props.history.push(`/Quotes/new${customerId ? `?customerId=${encodeURIComponent(customerId)}` : ""}`)
      }, "New quote"))
    }, rows === undefined ? /*#__PURE__*/React.createElement(Loader, null) : rows === null ? /*#__PURE__*/React.createElement("div", {
      className: "wa-grid"
    }, /*#__PURE__*/React.createElement(Card, {
      title: "Quotes"
    }, /*#__PURE__*/React.createElement("p", {
      className: "territory-hint",
      style: {
        margin: 0
      }
    }, "Quotes are not available yet for this workspace. The desk appears here once the quotes rail is enabled."))) : /*#__PURE__*/React.createElement("div", {
      className: "wa-grid"
    }, /*#__PURE__*/React.createElement(Card, {
      title: "Quotes",
      hint: `${list.length} of ${rows.length} · click a quote to open it`,
      right: /*#__PURE__*/React.createElement("span", {
        className: "qt-openline"
      }, c.open ? `Open ${c.open} · ${money0(c.openValue)}` : "No open quotes")
    }, /*#__PURE__*/React.createElement("div", {
      className: "wa-toolbar"
    }, /*#__PURE__*/React.createElement("span", {
      className: "qt-chips"
    }, chipList.map(x => /*#__PURE__*/React.createElement("button", {
      key: x.k,
      type: "button",
      className: `wa-chip${chip === x.k ? " on" : ""}`,
      onClick: () => this.setState({
        chip: chip === x.k ? "all" : x.k
      })
    }, /*#__PURE__*/React.createElement("span", {
      className: "k"
    }, x.l), " ", x.n))), /*#__PURE__*/React.createElement(Filters, null, /*#__PURE__*/React.createElement(PlunkDropDown, {
      width: "170px",
      value: rep,
      onChange: v => this.setState({
        rep: v
      }),
      options: [["", "Rep: all"], ...reps.map(r => [r.repCode, r.name || r.repCode])]
    }), /*#__PURE__*/React.createElement(PlunkDropDown, {
      width: "130px",
      value: owner,
      onChange: v => this.setState({
        owner: v
      }),
      options: [["", admin ? "Owner: all" : "Owner: team"], ["me", "Owner: me"]]
    }), /*#__PURE__*/React.createElement(Search, {
      value: q,
      onChange: v => this.setState({
        q: v
      }),
      placeholder: "Search number, dealer, title"
    }))), list.length === 0 ? /*#__PURE__*/React.createElement(Empty, null, rows.length === 0 ? "No quotes yet. Start one with New quote: pick the dealer, add lines from the catalog, send." : "No quotes match these filters.") : /*#__PURE__*/React.createElement("div", {
      className: "tblwrap"
    }, /*#__PURE__*/React.createElement("table", {
      className: "territory-table wa-table qt-table"
    }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Quote"), /*#__PURE__*/React.createElement("th", null, "Dealer"), /*#__PURE__*/React.createElement("th", null, "Rep"), /*#__PURE__*/React.createElement("th", null, "Status"), /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, "Net"), /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, "Valid until"), /*#__PURE__*/React.createElement("th", null, "Note"))), /*#__PURE__*/React.createElement("tbody", null, list.map(r => /*#__PURE__*/React.createElement("tr", {
      key: r.id,
      className: "clickable",
      onClick: () => this.open(r)
    }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("span", {
      className: "name"
    }, r.number || `Quote ${r.id}`, " ", /*#__PURE__*/React.createElement("span", {
      className: "plk-chip"
    }, "v", r.version)), r.title ? /*#__PURE__*/React.createElement("span", {
      className: "code"
    }, r.title) : null), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("span", {
      className: "name"
    }, r.customerName || r.customerId), r.customerNumber ? /*#__PURE__*/React.createElement("span", {
      className: "code"
    }, r.customerNumber) : null), /*#__PURE__*/React.createElement("td", null, r.repName || r.repCode || /*#__PURE__*/React.createElement("span", {
      className: "dim"
    }, "\u2014")), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(QuoteStatus, {
      q: r
    })), /*#__PURE__*/React.createElement("td", {
      className: "n"
    }, money0(r.subtotalNet)), /*#__PURE__*/React.createElement("td", {
      className: "n"
    }, fmtDate(r.validUntil, false) || "—"), /*#__PURE__*/React.createElement("td", {
      className: "dim"
    }, this.noteFor(r))))))), /*#__PURE__*/React.createElement("p", {
      className: "wa-foot"
    }, "Statuses: ", ["draft", "sent", "viewed", "converted", "declined", "expired"].map(quoteStatusLabel).join(" · "), ". An accepted quote is converted into an order request at once. Sent and viewed quotes within seven days of their validity read Expiring; a nightly job flips them to Expired on the day after.")))));
  }
}
export default withRouter(QuotesListView);